'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/6.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CrowdfundingMessageComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CrowdfundingMessageComponent, _Component);

  function CrowdfundingMessageComponent() {
    (0, _classCallCheck3.default)(this, CrowdfundingMessageComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CrowdfundingMessageComponent).call(this));
  }

  (0, _createClass3.default)(CrowdfundingMessageComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./CrowdfundingMessageComponent.scss');
      var _props = this.props;
      var index = _props.index;
      var message = _props.message;

      var currentClassName = '';
      if (index % 2 === 0) {
        currentClassName = styles.gray;
      }
      return _react2.default.createElement(
        'tr',
        { className: currentClassName },
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          _react2.default.createElement('img', { className: styles.mt, src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio_hover.png' })
        ),
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          '2016/09/06' || message.date
        ),
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          '艺品网' || message.addresser
        ),
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          '《东阳木雕》众筹成功' || message.title
        ),
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          '尊敬的客户，你参加的《东阳木雕》众筹成功...完成度268%...' || message.content
        ),
        _react2.default.createElement(
          'td',
          { className: styles.crowdfundingTd },
          _react2.default.createElement(
            'a',
            { className: styles.bttn },
            '查看'
          )
        )
      );
    }
  }]);
  return CrowdfundingMessageComponent;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number,
  message: _react.PropTypes.array
}, _temp);
exports.default = CrowdfundingMessageComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CrowdfundingMessageComponent/CrowdfundingMessageComponent.js
 ** module id = 1321
 ** module chunks = 0
 **/